import React, { ReactElement } from 'react';
import { FormikStepProps } from "./FormikStep";

type BreadcrumbsProps = {
    steps: Array<ReactElement<FormikStepProps>>,
    currentStep: number,
    stepChangeCallback: Function,
    children?: React.ReactNode
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
    return <div className="pds-u-padding-top-20">
        <progress max="1" value={props.currentStep / (props.steps.length - 2)} style={{ width: '100%', accentColor: '#0061a0' }}/>
    </div>;
};

export default Breadcrumbs;